import DOMPurify from 'dompurify';

const SANITIZE_OPTIONS = {
  USE_PROFILES: { html: true },
  ALLOWED_ATTR: ['href', 'src', 'alt', 'target', 'rel', 'class'],
};

export const sanitizeHtml = (value) =>
  DOMPurify.sanitize(value || '', SANITIZE_OPTIONS);
